<template>
  <component v-bind:is="layout"></component>
</template>

<script>
import Admin from '@/views/layout/Admin.vue';
import Loading from '@/views/layout/Loading';
import Blank from '@/views/layout/Blank';

export default {
  name: 'App',
  computed: {
    layout () {
      return this.$store.getters.getLayout;
    }
  },
  components: {
    'admin': Admin,   
    'loading': Loading,
    'blank': Blank
  }
}
</script>